import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import "./index.scss";

import App from "./App";
import { initialize } from "./init";
import { AppProvider } from "./AppContext";

if (process.env.NODE_ENV !== "production") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

initialize().then((result) => {
  const container = document.getElementById("root");
  const { store, api } = result;

  if (!result) {
    container.innerText = "Something went wrong";
    return;
  }

  const root = createRoot(container);
  root.render(
    <AppProvider value={{ api }}>
      <Provider store={store}>
        <App />
      </Provider>
    </AppProvider>
  );
});
